// extracted by mini-css-extract-plugin
export default {"Topic":"Topic_Topic__uMcUY"};